import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../../common/form';

import { matchPhrases } from '../../../utils/utilities';
import { DEFAULT_REPORT_TITLE } from '../../../utils/constants';

import toastService from '../../../services/toastService';

class ReportTitleForm extends Form {
	state = {
		data: {
			projectTitleType: 'defaultTitle',
			projectTitle: DEFAULT_REPORT_TITLE,
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		projectTitleType: Joi.string()
			.min(3)
			.required()
			.label('Project Title Type'),
		projectTitle: Joi.string().min(3).required().label('Project Title'),
	};

	static propTypes = {
		projectTitle: PropTypes.string,
		onAdd: PropTypes.func,
	};

	doSubmit = (): void => {
		this.props.onAdd(this.state.data.projectTitle);

		toastService.success('Report Title Saved Successfully!');
	};

	componentDidUpdate(
		prevProps: Readonly<any>,
		prevState: Readonly<{
			data: any;
			errors: any;
			progress: number;
			loading: boolean;
		}>,
		snapshot?: any
	): void {
		if (prevState.data.projectTitleType !== this.state.data.projectTitleType) {
			this.handleTitleTypeChange(this.state.data.projectTitleType);
		}
	}
	handleTitleTypeChange = (titleType: string) => {
		const data = { ...this.state.data };

		switch (titleType) {
			case 'projectTitle':
				if (this.props.projectTitle) {
					data.projectTitle = this.props.projectTitle;
				} else {
					toastService.error('Project title is not available!');
				}

				break;

			case 'defaultTitle':
				data.projectTitle = DEFAULT_REPORT_TITLE;
				break;

			case 'customTitle':
				data.projectTitle = '';
				break;

			default:
		}

		this.setState({ data });
	};

	render() {
		const { projectTitleType } = this.state.data;

		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				{this.renderSelect({
					name: 'projectTitleType',
					placeholder: 'Select Title Type',
					label: 'Title Type:',
					options: titleOptions,
				})}

				<div className="my-4 divider"></div>

				{this.renderInput({
					type: 'text',
					name: 'projectTitle',
					placeholder: 'Enter Project Title',
					label: 'Project Title',
					readOnly: !matchPhrases(projectTitleType, 'customTitle'),
				})}

				<div className="my-4 divider"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Save Project Title')}
				</div>
			</form>
		);
	}
}

const titleOptions = [
	{
		id: 'projectTitle',
		name: 'Use Project Title',
	},
	{
		id: 'defaultTitle',
		name: 'Use Default Title',
	},
	{
		id: 'customTitle',
		name: 'Use Custom Title',
	},
];

export default ReportTitleForm;
